import { observer } from 'mobx-react';
import React from 'react';
import { getAppContext } from '~/lib/AppContext';
import './NotificationCenter.scss';
import UnmountHelper from '~/lib/helper/UnmountHelper';
import { action, makeObservable, observable } from 'mobx';
import SearchModal from './SearchModal';
import { SearchStore } from '~/lib/store/SearchStore';

@observer
export default class Search extends React.Component {
    mountHelper = new UnmountHelper(this);

    searchStore = new SearchStore(getAppContext().apiClient, getAppContext().siteApiClient);

    @observable
    show = false;

    constructor(props: Record<string, never>) {
        super(props);
        makeObservable(this);
    }

    @action
    toggle(show: boolean) {
        this.show = show;
    }

    componentDidMount() {
        const disposer = getAppContext().showSearch.on((show: boolean) => {
            this.toggle(show);
        });

        this.mountHelper.listenUntilUnmounted(document.body, 'keydown', (e) => {
            // toggle the modal when / is pressed
            if (e.key === '/') {
                // Check if the active element is not an input or textarea
                if (
                    !(document.activeElement instanceof HTMLInputElement) &&
                    !(document.activeElement instanceof HTMLTextAreaElement)
                ) {
                    e.preventDefault(); // Prevent the key from being typed
                    this.toggle(true);
                }
            }
        });

        this.mountHelper.onUnmount(disposer);
    }

    render() {
        if (!this.show) return null;
        return <SearchModal onClose={() => this.toggle(false)} searchStore={this.searchStore} />;
    }
}
